<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div class="overlay-content">
    <i class="ri-upload-cloud-line text-8xl" aria-hidden="true" />
    <span class="text-xl font-bold">{{ $t("dropFileFolders") }} </span>
    <div class="mt-2 text-color-secondary">
      {{
        currentNode?.name === "documentLibrary"
          ? workspace?.title || workspace?.id
          : currentNode?.name || $t("currentFolder")
      }}
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useNavigationStore } from "@/stores/navigation.js";
export default {
  name: "UploadTargetInfo",
  computed: {
    ...mapState(useNavigationStore, ["currentNode", "workspace"]),
  },
};
</script>
<style scoped>
.overlay-content {
  pointer-events: none;
  background-color: white;
  border-radius: 28px;
  padding: 2rem 3rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  max-width: 90%;
  animation: drive-pop-in 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
</style>
